// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import { createApp } from 'vue';
import vuetify from '@/plugins/vuetify'; // path to vuetify export
import App from './App.vue';
import router from './router';
import { createI18n } from 'vue-i18n';
import DropdownMenu from 'v-dropdown-menu';
import VueResizeText from 'vue-resize-text';
import 'v-calendar/style.css';
import config from '@/formkit.config.js';
import { plugin, defaultConfig } from '@formkit/vue';
import { SnackbarService } from 'vue3-snackbar';
import VueCookieComply from 'vue-cookie-comply';
import 'vue-cookie-comply/dist/style.css';
import 'vue3-snackbar/styles';
import VueNumberInput from '@chenfengyuan/vue-number-input';
import VCalendar from 'v-calendar';
import { loadFonts } from './plugins/webfontloader';
import store from './store/index';

// Load locale messages
function loadLocaleMessages() {
  const locales = require.context(
    '@/locales',
    true,
    /[A-Za-z0-9-_,\s]+\.json$/i
  );
  const messages = {};
  locales.keys().forEach((key) => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i);
    if (matched && matched.length > 1) {
      const locale = matched[1];
      messages[locale] = locales(key);
    }
  });
  return messages;
}

const messages = loadLocaleMessages();

const i18n = createI18n({
  legacy: false,
  locale: 'en',
  fallbackLocale: 'en',
  messages
});

// Initialize Vue app
const app = createApp(App);

// Use plugins
app.use(router);
app.use(store);
app.use(vuetify);
app.use(i18n);
app.use(DropdownMenu);
app.use(VueResizeText);
app.use(plugin, defaultConfig(config));
app.use(SnackbarService);
app.use(VueCookieComply);
app.use(VCalendar, {});

// Register components
app.component(VueNumberInput.name, VueNumberInput);

// Load fonts
loadFonts();

// Mount app
app.mount('#app');
